import { HttpResult, loadedAsyncState, loadingAsyncState } from "widgets-for-react"
import { popupSrc, popupSrcSet } from "../drupal/utils/imageSizes"
import { parseDrupalImageUrls } from "../drupal/utils/modernImage"
import { DrupalPopup, PopupState } from "./popup.state"
import { getCookie, setCookie } from "../../../../Shared/Frontend/utils/cookies"
import { Entity } from "ts-lenses"
import { CMSBlocksState } from "../cmsPage.state"

export const loadPreviewPopups = () => loadPopupRequest(`/api/drupal/getPopupPreview`)
export const loadPopup = async (nodeId: string) => loadPopupRequest(`/api/drupal/getPopup?nodeId=${nodeId}`)

const loadPopupRequest = async (uri: string): Promise<HttpResult<Array<DrupalPopup>>> => {
  try {
    let headers = new Headers()
    headers.append('content-type', 'application/json')
    headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

    let res = await fetch(uri, {
      method: 'get', credentials: 'include', headers: headers
    })

    if (!res.ok) throw Error(res.statusText)
    let array = await res.json() as any[]

    const parsed: DrupalPopup[] = array.map(json => {
      const img = json.Image ? JSON.parse(json.Image) : undefined
      const fieldMediaImage = img?.field_media_image[0]
      const fieldMediaSource = img?.field_source[0]
        ? img?.field_source
        : undefined
      const dpImages = fieldMediaImage
        ? parseDrupalImageUrls(fieldMediaImage, fieldMediaSource, popupSrcSet, popupSrc)?.image
        : undefined

      return {
        ...json,
        open: true,
        image: dpImages
      }
    })


    return {
      kind: 'result',
      status: 200,
      value: parsed
    }
  } catch (e) {
    console.error("Error when fetching popup")
    console.error(e)

    return {
      kind: 'failed',
      status: 500
    }
  }
}

export function getPopups(popupState: PopupState, cmsBlocksState: CMSBlocksState) {
  if (popupWasClosed(popupState)) return popupState

  if (cmsBlocksState.loader.kind == "loaded") {
    const page = cmsBlocksState.loader.value.pageData
    if (page.page.nodeId) {
      return Entity(popupState)
        .set("popups", _ => loadingAsyncState(() => loadPopup(page.page.nodeId)))
        .commit()
    }
  }

  return popupState
}

export const updaters = {
  closePopup: (s0: PopupState, index: number) => {
    if (s0.popups.kind !== "loaded") return s0
    let popups = s0.popups.value.map((p, popupIndex) => {
      if (popupIndex != index) return p
      return Entity(p)
        .set("open", _ => false)
        .commit()
    })

    setClosedCookie()

    return Entity(s0)
      .set("popups", _ => loadedAsyncState(popups))
      .commit()
  }
}

const closedCookieName = "popupClosed"
const setClosedCookie = () => {
  setCookie(closedCookieName, String(true), 0)
}

export const popupWasClosed = (state: PopupState) => {
  if (state.preview) return false
  const closedCookie = getCookie(closedCookieName)
  return Boolean(closedCookie)
}
